import {useCheckboxSelection} from "../Checkbox";
import {Button, Grid, Menu, MenuItem} from "@mui/material";
import {useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useTableData, useTableRefresher} from "../../../../misc/scroller/Table";
import {logisticsTableName} from "./Logistics";
import {useProjectId} from "../ProjectName";
import { Loader } from "../../../../misc/Loader";
import {InventoryRequest, InvSource} from "../../../../api/Logistics";
import {useSnackbar} from "../../../../misc/Snackbar";

export function BulkSource(props: {
    type: string;
    anchorEl: HTMLElement | null;
    onOpen(): void;
}) {
    const sel = useCheckboxSelection()
    const [open, setOpen] = useState(false);

    const project = useProjectId();
    const refresher = useTableRefresher(logisticsTableName(project, props.type));
    const data = useTableData(logisticsTableName(project, props.type)) as InventoryRequest[]
    const values = data.filter(d => sel.indexOf(d.id) !== -1 && (d.status === "released" || d.status === "in-warehouse"));
    const snack = useSnackbar();

    const update = useAsyncAction(async (input: {
        ids: number[];
        overrideSource?: InvSource;
    }) => {
        const result = await api.logistics.bulkUpdateInventoryRequest(input);

        if(!result.skippedForStockLimits || result.skippedForStockLimits.length === 0) {
            snack.success("Updated")
        } else {
            snack.success(`Updated, ${result.skippedForStockLimits.length} skipped for stock limits`);
        }

        setOpen(false);
        refresher()
    }, [refresher]);

    return <>
        <MenuItem disabled={values.length === 0} onClick={() => {
            props.onOpen();
            setOpen(true);
        }}>Bulk Source</MenuItem>

        {open && <Menu open anchorEl={props.anchorEl} onClose={() => setOpen(false)}>
            <Loader {...update} />
            <MenuItem onClick={() => {
                update.callback({
                    ids: values.map(v => v.id),
                    overrideSource: "purchase",
                })
            }}>From Purchasing</MenuItem>
            <MenuItem onClick={() => {
                update.callback({
                    ids: values.map(v => v.id),
                    overrideSource: "non-stocking",
                })
            }}>From Warehouse</MenuItem>
            <Grid container spacing={1} justifyContent="flex-end" style={{paddingRight: 10, paddingBottom: 0, paddingTop: 8}}>
                <Grid item>
                    <Button onClick={() => setOpen(false)} size="small">Cancel</Button>
                </Grid>
            </Grid>
        </Menu>}
    </>
}